/* https://support.justuno.com/en/firing-script-after-justuno-has-loaded
 the callback fn didn't work as at time of fire the content in the dom hasn't been loaded yet and
 as a result the height of the element was wrong. Also attempted using a mutation observer but had
 same issue
*/

function updateJustunoCssProp() {
  const justunoContainerEl = document.querySelector('.ju_Con');
  if (!justunoContainerEl) return;
  const announcementBarHeight = justunoContainerEl.offsetHeight;
  const root = document.documentElement;
  root.style.setProperty('--justuno-announcement-bar-height', `${announcementBarHeight}px`);
}

function waitForJustuno() {
  const intervalID = setInterval(() => {
    if (!window.ju_initialized) return;
    const justunoContainerEl = document.querySelector('.ju_Con');
    if (justunoContainerEl) {
      updateJustunoCssProp();
      clearInterval(intervalID);
    }
  }, 1000);

  // to prevent this interval from running forever we'll clear it after 10 seconds
  setTimeout(() => {
    clearInterval(intervalID);
  }, 10000);
}

// eslint-disable-next-line no-unused-expressions
window.ju_initialized ? updateJustunoCssProp() : waitForJustuno();
